module.exports = __webpack_public_path__ + "static/media/page404-1.c96db471.png";